import { SPECIAL_PRICE_SCOPE_QUALIFIER_KEYS } from '../constant/constantspecial'
import {
  SPECIAL_PRICE_ACTION_BUTTON_SX,
  SPECIAL_PRICE_DANGER_ACTION_BUTTON_SX,
  SPECIAL_PRICE_SHOW_ACTION_LABELS,
  SPECIAL_PRICE_SHOW_DETAIL_LABELS,
  SPECIAL_PRICE_SHOW_SCALE_LABELS
} from '../constant/specialPriceViewConstants'
import { formatDateForDisplay } from './specialPriceHelpers'

export const buildSpecialPriceDetailRows = (details = {}) => {
  const rows = [
    {
      label: SPECIAL_PRICE_SHOW_DETAIL_LABELS.code,
      value: details.external_db_ref || '-'
    },
    {
      label: SPECIAL_PRICE_SHOW_DETAIL_LABELS.scope,
      value: details.scope_label || '-'
    },
    {
      label: SPECIAL_PRICE_SHOW_DETAIL_LABELS.dateRange,
      type: 'date_range',
      startDate: formatDateForDisplay(details.start_date),
      endDate: formatDateForDisplay(details.end_date)
    }
  ]

  if (details.scope_type === 'attribute') {
    SPECIAL_PRICE_SCOPE_QUALIFIER_KEYS.forEach((key, index) => {
      const values = details.scope_filters?.[key]
      if (!values || (Array.isArray(values) && values.length === 0)) return

      rows.push({
        label: `Atributo ${String.fromCharCode(65 + index)}`,
        value: Array.isArray(values) ? values.join(', ') : values
      })
    })
  }

  if (details.scope_type === 'client') {
    rows.push({
      label: SPECIAL_PRICE_SHOW_DETAIL_LABELS.client,
      value: details.client_name || details.client_db_ref || '-'
    })
  }

  return rows
}

export const buildSpecialPriceHeaderActions = ({
  status,
  onSuspend,
  onCopy
}) => [
  ...(status !== 'suspended'
    ? [
        {
          key: 'suspend',
          label: SPECIAL_PRICE_SHOW_ACTION_LABELS.suspend,
          variant: 'outlined',
          icon: 'close',
          iconProps: {
            filled: false,
            size: 22
          },
          onClick: onSuspend,
          sx: SPECIAL_PRICE_DANGER_ACTION_BUTTON_SX
        }
      ]
    : []),
  {
    key: 'copy',
    label: SPECIAL_PRICE_SHOW_ACTION_LABELS.copy,
    variant: 'contained',
    icon: 'layers',
    iconProps: {
      filled: false,
      size: 22,
      color: '#ffffff'
    },
    onClick: onCopy,
    sx: SPECIAL_PRICE_ACTION_BUTTON_SX
  }
]

export const buildScaleFieldLabel = (label, salesUnit) =>
  `${label}${salesUnit ? ` (${salesUnit})` : ''}`

export const getScaleMaxQtyValue = (maxQty) =>
  maxQty == null ? SPECIAL_PRICE_SHOW_SCALE_LABELS.unlimited : String(maxQty)
